let region = false;

export const RegionService = {

    getRegion: () => region,

    setRegion: (value) => { region = value }

};

export default RegionService;